import { Thunk } from '@/redux/types';
import { selectBasketStatus } from '../getters/selectBasketStatus';
import { BasketSetAction } from '../types';
import { loadBasketAction } from './loadBasketAction';

export const initBasketAction =
  (basketId?: string): Thunk<void, BasketSetAction> =>
  (dispatch, getState) => {
    if (basketId && selectBasketStatus(getState()) === 'initial') {
      dispatch(loadBasketAction(basketId));
    }
  };
